import Swiper from 'Swiper';
import Masonry from 'masonry-layout'
import GLightbox from 'glightbox'

jQuery(document).ready(function ($) {
  const lightbox = GLightbox();
  $('.faq__question').on('click', function(){
    var parent = $(this).parents('.faq__item');
    $(parent).addClass('active').siblings().removeClass('active').find('.faq__answer').slideUp();
    $(parent).find('.faq__answer').slideToggle();
  })


  var gallery = new Swiper('.gallery', {
    // autoplay: true,
    // loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
  });



  var grid = document.querySelector('.masonry-gallery');
  if( $(grid).length > 0 ){
    var msnry = new Masonry( grid, {
      itemSelector: '.masonry-gallery__item',
      horizontalOrder: true,
    });
  }


  $('.categories__tab li').on('click', function(){
    let tab = $(this).attr('data-tab');
    $(this).addClass('active').siblings().removeClass('active');
    $(tab).addClass('active').siblings().removeClass('active');
  })

  function mapInit() {
    let selector = $("html").attr("lang");
    switch (selector) {
      case "en_US":
        $('[data-location="ro"]').addClass("location--active");
        break;
      case "ro_RO":
        $('[data-location="ro"]').addClass("location--active");
        break;
      case "fr_FR":
        $('[data-location="fr"]').addClass("location--active");
        break;
      case "de_DE":
        $('[data-location="au"]').addClass("location--active");
        break;
      case "it_IT":
        $('[data-location="it"]').addClass("location--active");
        break;
      default:
        $('[data-location="ro"]').addClass("location--active");
    }
  }
  
  mapInit(); 
  
  $('path.location').on('click', function(){
    $('#interactive-map .location--active').removeClass('location--active');
    var location = $(this).attr('data-location');
    $('[data-location='+location+']').addClass('location--active');
    $('.loc').removeClass('active')
    $('.loc.'+location).addClass('active');
  })


  $('.burger').on('click', function(){
    $('body').removeClass('sticky').toggleClass('show-menu');
    $('header.header').removeClass('slideInDown');
    $('.nav__overlay').fadeToggle();
  })


  $(window).scroll(function () {
    if(!$('body').hasClass('show-menu')){
        if ($(window).scrollTop() > 250  ) {
            $('body').addClass('sticky');
            $('header.header').addClass('slideInDown');
        }
        if ($(window).scrollTop() < 250) {
            $('body').removeClass('sticky');
            $('header.header').removeClass('slideInDown');
        }
    }
});

});


